module.exports = __webpack_public_path__ + "img/team-dark-02.cace13fe.jpg";